import { Product } from "../context/SearchContext";
import {
  AnalyticsPayload,
  submitAnalytics,
} from "../services/AnalyticsService";
import { AnswerComponent } from "../services/AnswerComponentsService";
import { Source } from "../services/PipelineService";

interface DigitalDataActionPayload {
  action: {
    group: string;
    category: string;
    name: string;
    label: string;
  };
  metadataList?: Array<{
    key: string;
    value: string;
  }>;
  event: "trackAction";
}

interface DigitalDataElementPayload {
  element: {
    container: string;
    type: string;
    name: string;
  };
  event: "trackElement";
}

interface DigitalDataPromotionPayload {
  promotion: {
    name: string;
    creative: string;
    position: string;
  };
  event: string;
}
export const sendDigitalDataAction = (
  group: string,
  category: string,
  name: string,
  label: string,
  metadataList?: Array<{ key: string; value: string }>,
) => {
  const payload: DigitalDataActionPayload = {
    action: {
      group,
      category,
      name,
      label,
    },
    event: "trackAction",
  };

  if (metadataList) {
    payload.metadataList = metadataList;
  }

  parent.postMessage(
    {
      type: "digitalData",
      payload,
    },
    "*",
  );
};

export const sendDigitalDataElement = (
  container: string,
  type: string,
  name: string,
) => {
  const payload: DigitalDataElementPayload = {
    element: {
      container,
      type,
      name,
    },
    event: "trackElement",
  };

  parent.postMessage(
    {
      type: "digitalData",
      payload,
    },
    "*",
  );
};

export const sendDigitalDataPromotion = (
  name: string,
  creative: string,
  position: string,
  event: string,
) => {
  const payload: DigitalDataPromotionPayload = {
    promotion: {
      name,
      creative,
      position,
    },
    event,
  };

  parent.postMessage(
    {
      type: "digitalData",
      payload,
    },
    "*",
  );
};
// Old postMessage events ------------------------------------------------------------

export const sendSearchResponse = (
  query: string,
  requestId: string,
  textResponse: string,
  sources: Source[],
  duration: number,
  contextId: string,
  products: Product[],
  agentId: string,
  answerComponents: AnswerComponent[],
) => {
  const payload: AnalyticsPayload = {
    action: "search:response",
    requestId,
    contextId,
    query,
    textResponse,
    sources,
    duration,
    description: "Respuesta final de búsqueda generada",
    datetime: new Date().toISOString(),
    products,
    agentId: agentId,
    answerComponents,
  };
  parent.postMessage(payload, "*");
  submitAnalytics(payload);
};

export const sendSearchOpened = (contextId: string) => {
  const payload: AnalyticsPayload = {
    action: "search:open",
    contextId,
    description: "Buscador abierto",
    datetime: new Date().toISOString(),
  };

  submitAnalytics(payload);
};

// Updated events ------------------------------------------------------------

// In BCP Tagging document: 2. Finalización correcta de onboarding
export const sendFinishOnboardingClick = () => {
  sendDigitalDataAction("IABuscador", "Onboarding", "Click", "Comenzar");

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 3. Selección de elemento cerrar (x) del onboarding
export const sendCloseOnboardingClick = (step: string) => {
  const container = `IABuscador-Onboarding-${step}`;
  sendDigitalDataElement(container, "Click", "Cerrar");

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 4. Selección dentro del menú principal
export const sendMenuClick = (option: string) => {
  sendDigitalDataAction("IABuscador", "Principal", "Click", option);

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 5. Selección de preguntas sugeridas
export const sendExploreQueriesClick = (query: string) => {
  sendDigitalDataAction("IABuscador", "Explora más preguntas", "Click", query);

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 6. Cerrar Preguntas Sugeridas
export const sendExploreQueriesExitClick = () => {
  sendDigitalDataElement(
    "IABuscador - Explora más preguntas",
    "Click",
    "Cerrar",
  );

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 7. Búsqueda - Preguntas sugeridas
export const sendSearchClick = (
  query: string,
  position: string,
  searchType: string,
  requestId: string,
  contextId: string,
  suggestedQueries: string[],
  agentId: string,
) => {
  const positionLabel = position === "initial" ? "Inicio" : "Interno";
  const searchTypeLabel =
    searchType === "keyword"
      ? "Keyword"
      : searchType === "suggestion"
        ? "Sugerida"
        : searchType;
  const category = `${positionLabel}-${searchTypeLabel}`;
  const metadataList = [
    {
      key: "Pregunta",
      value: query,
    },
    {
      key: "Posicion Pregunta",
      value: positionLabel,
    },
    {
      key: "Tipo de búsqueda",
      value: searchTypeLabel,
    },
  ];
  if (searchType === "keyword" || searchType === "suggestion") {
    sendDigitalDataAction(
      "IABuscador",
      category,
      "Click",
      "Buscar",
      metadataList,
    );
  }

  const action =
    searchType === "suggestion"
      ? "search:suggestion"
      : position === "initial"
        ? "search:initial"
        : "search:internal";

  // TODO: Migrate to new analytics
  const payload: AnalyticsPayload = {
    action,
    requestId,
    contextId,
    query,
    description: "Click en botón buscar",
    datetime: new Date().toISOString(),
    suggestedQueries,
    agentId: agentId,
  };

  submitAnalytics(payload);
};

// In BCP Tagging document: 8. Selección de un elemento de texto dentro de la búsqueda
export const sendResponseLinkClick = (
  query: string,
  requestId: string,
  href: string,
  hrefText: string,
  contextId: string,
) => {
  const name = `Resultados-${hrefText}-${href}`;
  sendDigitalDataElement("IABuscador", "Text Link", name);

  // TODO: Migrate to new analytics
  const payload: AnalyticsPayload = {
    action: "response:linkClick",
    requestId,
    contextId,
    query,
    href,
    hrefText,
    description: "Click en enlace de respuesta",
    datetime: new Date().toISOString(),
  };

  submitAnalytics(payload);
};

// In BCP Tagging document: 9. Selección de preguntas relacionadas
export const sendRelatedQuestionClick = (question: string) => {
  sendDigitalDataAction(
    "IABuscador",
    "Preguntas relacionadas",
    "Click",
    question,
  );

  // TODO: Migrate to new analytics
};

// In BCP Tagging document: 10. Selección de preguntas relacionadas
export const sendSourceLinkClick = (
  query: string,
  requestId: string,
  sourceLabel: string,
  href: string,
  hrefText: string,
  contextId: string,
) => {
  const label = `${sourceLabel}-${hrefText}-${href}`;
  sendDigitalDataAction("IABuscador", "Mas informacion", "Click", label);

  // TODO: Migrate to new analytics
  const payload: AnalyticsPayload = {
    action: "source:linkClick",
    requestId,
    contextId,
    query,
    href,
    hrefText,
    description: "Click en enlace de fuente",
    datetime: new Date().toISOString(),
  };

  submitAnalytics(payload);
};

// In BCP Tagging document: 11. Selección de cards sugeridos
export const sendCardClick = (
  label: string,
  answerComponentId: string,
  url: string,
  requestId: string,
  contextId: string,
) => {
  sendDigitalDataAction(
    "IABuscador",
    "Respuesta-Card Sugerido",
    "Click",
    label,
  );

  // TODO: Migrate to new analytics
  const payload: AnalyticsPayload = {
    action: `click:cta:${answerComponentId}`,
    requestId,
    contextId,
    href: url,
    hrefText: label,
    description: "Click en enlace de CTA",
    datetime: new Date().toISOString(),
  };

  submitAnalytics(payload);
};

// In BCP Tagging document: 12. Selección de valorización NPS
export const sendUserFeedbackSelected = (
  requestId: string,
  query: string,
  feedbackCategory: string,
  contextId: string,
) => {
  const feedbackLabel =
    feedbackCategory === "positive" ? "Positivo" : "Negativo";
  sendDigitalDataAction("IABuscador", "NPS", "Click", feedbackLabel);

  // TODO: Migrate to new analytics
  const payload: AnalyticsPayload = {
    action: "feedback:select",
    requestId,
    contextId,
    query,
    feedbackCategory,
    description: "Usuario selecciona categoría de feedback",
    datetime: new Date().toISOString(),
  };

  submitAnalytics(payload);
};

// In BCP Tagging document: 13. Envío de NPS para la Búsqueda
export const sendUserFeedback = (
  requestId: string,
  query: string,
  feedbackCategory: string,
  selectedOptions: string[],
  comment: string,
  contextId: string,
  textResponse: string,
  sources: Source[],
  duration: number,
  products: Product[],
  answerComponents: AnswerComponent[],
) => {
  const feedbackLabel =
    feedbackCategory === "positive" ? "Positivo" : "Negativo";

  const metadataList = [
    { key: "IANPS-Valor", value: feedbackLabel },
    ...selectedOptions.map((option) => ({
      key: "IANPS-Que te gusto",
      value: option,
    })),
  ];

  sendDigitalDataAction("IABuscador", "NPS", "Click", "Enviar", metadataList);

  const payload: AnalyticsPayload = {
    action: "feedback:submit",
    requestId,
    contextId,
    query,
    feedbackCategory,
    selectedOptions,
    comment,
    description: "Feedback del usuario enviado",
    datetime: new Date().toISOString(),
    textResponse,
    sources,
    duration,
    products,
    answerComponents,
  };
  parent.postMessage(payload, "*");
  submitAnalytics(payload);
};

// In BCP Tagging document: 14.Selección del cierre de buscador
export const sendCloseClick = () => {
  sendDigitalDataElement("IABuscador", "Cerrar", "Click");

  // TODO: Migrate to new analytics
};

export const sendTutorialVisualized = (query: string) => {
  const name = "Respuesta-Tutorial";
  const creative = "IABuscador";
  sendDigitalDataPromotion(name, creative, query, "trackPromotionView");
};

export const sendTutorialStepClick = (query: string, direction: string) => {
  const name = `Respuesta-Tutorial-Flecha-${direction}`;
  const creative = "IABuscador";
  sendDigitalDataPromotion(name, creative, query, "trackPromotionClick");
};

export const sendTutorialCtaClick = (cta: string) => {
  sendDigitalDataAction("IABuscador", "Respuesta-Tutorial-Boton", "Click", cta);
};
